var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"footer",attrs:{"id":"footer"}},[_c('p',{staticClass:"pc"},[_vm._v("文字內容｜蔡詠全、廖婉馨、李其樺 視覺設計｜周映璇 網頁設計｜黃莘懿")]),_c('p',{staticClass:"mb"},[_vm._v("文字內容｜蔡詠全、廖婉馨、李其樺"),_c('br'),_vm._v(" 視覺設計｜周映璇"),_c('br'),_vm._v(" 網頁設計｜黃莘懿"),_c('br')]),_c('p',[_vm._v(" Copyright © 2023 民視新聞網路部 社群中心")])])])
}]

export { render, staticRenderFns }